export default ($timeout) => ({
  restrict: "A",
  link(scope, el, attrs) {
    let isHolding, timeoutId;

    el.on("mousedown touchstart", ($event) => {
      scope.$event = $event;
      isHolding = true;

      //TODO: implement timeout passing via attribute like here:
      //https://github.com/angular-ui/angular-ui/blob/master/modules/directives/keypress/keypress.js
      timeoutId = $timeout(function () {
        if (isHolding) {
          scope.$apply(attrs.ngHold);
          $event.preventDefault();
          $event.stopPropagation();
        }
      }, attrs.holdThreshold || attrs.holdTimeout || 500);
    });

    el.on("mouseup touchend", function () {
      isHolding = false;

      if (timeoutId) {
        $timeout.cancel(timeoutId);
        timeoutId = null;
      }
    });
  },
});
